import { render, staticRenderFns } from "./QueueCallListFactory.vue?vue&type=template&id=fdd99700&scoped=true"
import script from "./QueueCallListFactory.vue?vue&type=script&lang=js"
export * from "./QueueCallListFactory.vue?vue&type=script&lang=js"
import style0 from "./QueueCallListFactory.vue?vue&type=style&index=0&id=fdd99700&prod&lang=css"
import style1 from "./QueueCallListFactory.vue?vue&type=style&index=1&id=fdd99700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd99700",
  null
  
)

export default component.exports